var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"svg-stroke category-color","stroke":"#003B1B","strokeWidth":"1.6","strokeLinecap":"square"},[React.createElement("path",{"d":"M0.4,6.46331409 L14.0453125,6.46331409","key":0}),React.createElement("path",{"d":"M8.3820381,3.624823 L16.4902049,3.687677","transform":"translate(12.436122, 3.656250) rotate(-315.000000) translate(-12.436122, -3.656250) ","key":1}),React.createElement("path",{"d":"M8.3820381,9.375177 L16.4902049,9.312323","transform":"translate(12.436122, 9.343750) rotate(-45.000000) translate(-12.436122, -9.343750) ","key":2})]));
}

RightArrow.defaultProps = {"className":"svg","width":"18px","height":"15px","viewBox":"0 0 18 15","version":"1.1"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
